import getApi from '@/services/GetApi';

export const createChatSessionId = (): string => `chat-${Date.now()}`;

export const buildConversationId = (apiKey: string, chatSessionId: string): string =>
  `${apiKey}-${chatSessionId}`;

export async function resolveChatApiKey(userSub?: string): Promise<string | undefined> {
  if (!userSub) return undefined;
  const response = await getApi(userSub);
  return response?.payload?.api_key;
}

export async function clearBackendConversation({
  userSub,
  authorization,
  chatSessionId,
}: {
  userSub?: string;
  authorization?: string;
  chatSessionId: string;
}): Promise<void> {
  const apiKey = await resolveChatApiKey(userSub);
  if (!apiKey) {
    console.warn('Cannot clear backend conversation: API key not available');
    return;
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${authorization ?? ''}`,
    'x-api-key': apiKey,
    'x-conversation-id': buildConversationId(apiKey, chatSessionId),
  };

  const response = await fetch(`${process.env.REACT_APP_URL_CHAT_API}clear`, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

  if (!response.ok) throw new Error('Network response was not ok');
}
